<ion-content [fullscreen]="true" [scrollY]="false">
  <!-- ── CAMERA VIEW ── -->
  <div class="camera-screen" *ngIf="!previewUrl">

    <!-- <video #videoElement autoplay playsinline muted class="camera-feed" [class.mirror]="facingMode === 'user'"></video> -->

    <video #videoElement autoplay playsinline muted class="camera-feed"
      [class.mirror-feed]="facingMode === 'user'"></video>

    <!-- Permission State -->
    <!-- <div class="permission-state" *ngIf="!isCameraActive && !isLoading">
      <div class="perm-icon">
        <ion-icon name="camera-outline"></ion-icon>
      </div>
      <p class="perm-title">Camera Access</p>
      <p class="perm-sub" *ngIf="!errorMessage">Tap below to open your camera</p>
      <p class="perm-error" *ngIf="errorMessage">{{ errorMessage }}</p>
      <button class="open-btn" (click)="startCamera()">
        {{ errorMessage ? 'Try Again' : 'Open Camera' }}
      </button>
    </div> -->

    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="spinner-ring"></div>
      <p class="loading-text">{{'custom_camera.starting_camera' | translate}}</p>
    </div>

    <!-- Top Bar -->
    <div class="top-bar" *ngIf="isCameraActive">
      <button class="icon-btn" (click)="stopCamera()">
        <ion-icon name="close"></ion-icon>
      </button>

      <!-- <div class="orientation-pill">
        <ion-icon [name]="orientationIcon"></ion-icon>
        <span>{{ deviceOrientation }}</span>
      </div> -->
      <button class="icon-btn" (click)="toggleFlash()">
        <ion-icon [name]="flashOn ? 'flash' : 'flash-off'"></ion-icon>
      </button>
    </div>

    <!-- Grid Overlay -->
    <!-- <div class="grid-overlay" *ngIf="isCameraActive && showGrid">
      <div class="grid-line h1"></div>
      <div class="grid-line h2"></div>
      <div class="grid-line v1"></div>
      <div class="grid-line v2"></div>
    </div> -->

    <!-- Focus Ring -->
    <div class="focus-ring" *ngIf="showFocusRing" [style.left.px]="focusX" [style.top.px]="focusY"></div>

    <!-- Zoom Bar -->
    <!-- <div class="zoom-bar" *ngIf="isCameraActive">
      <button class="zoom-btn" [class.active]="currentZoom === 1" (click)="setZoom(1)">1×</button>
      <button class="zoom-btn" [class.active]="currentZoom === 2" (click)="setZoom(2)">2×</button>
    </div> -->

    <div class="zoom-bar" *ngIf="isCameraActive">
      <div class="zoom-pill">

        <!-- Slider (shown when label is tapped) -->
        <div class="zoom-slider-wrap" [class.visible]="zoomSliderOpen">
          <button class="zoom-close-btn" (click)="zoomSliderOpen = false">✕</button>
          <input type="range" min="10" max="20" step="1" [value]="currentZoom * 10" (input)="onZoomSlider($event)" />
        </div>

        <!-- Snap buttons + live label -->
        <button class="zoom-snap" [class.active]="currentZoom === 1" (click)="snapZoom(1)">1×</button>
        <div class="zoom-label" (click)="zoomSliderOpen = !zoomSliderOpen">{{ currentZoom | number:'1.1-1' }}×</div>
        <button class="zoom-snap" [class.active]="currentZoom === 2" (click)="snapZoom(2)">2×</button>

      </div>
    </div>
    <!-- Mode Bar -->
    <!-- <div class="mode-bar" *ngIf="isCameraActive">
      <span class="mode-item active">PHOTO</span>
    </div> -->

    <!-- Bottom Bar -->
    <div class="bottom-bar" *ngIf="isCameraActive">
      <!-- <div class="thumb-wrapper" (click)="viewLastPhoto()">
        <img *ngIf="lastPhoto" [src]="lastPhoto" class="last-thumb" />
        <div *ngIf="!lastPhoto" class="thumb-empty"></div>
      </div> -->
      <div style="width: 54px; height: 54px;">

      </div>
      <button class="shutter-btn" (click)="capturePhoto()" [class.pressed]="shutterPressed">
        <div class="shutter-ring">
          <div class="shutter-inner"></div>
        </div>
      </button>

      <button class="icon-btn flip-btn" (click)="switchCamera()">
        <ion-icon name="sync"></ion-icon>
      </button>
    </div>

    <!-- Grid Toggle -->
    <!-- <button class="grid-toggle" *ngIf="isCameraActive" (click)="showGrid = !showGrid">
      <ion-icon name="grid-outline"></ion-icon>
    </button> -->

  </div>

  <!-- ── PREVIEW VIEW ── -->
  <div class="preview-screen" *ngIf="previewUrl && !isNativeCamera">

    <!-- Processing Overlay -->
    <div class="processing-overlay" *ngIf="isProcessing">
      <div class="spinner-ring"></div>
    </div>

    <div class="preview-container">
      <img [src]="previewUrl" class="preview-img" />
    </div>

    <!-- Focus Quality Badge -->
    <!-- <div class="focus-badge" *ngIf="!isProcessing && !isFocusChecking && focusLabel" [style.border-color]="focusColor">
      <div class="focus-dot" [style.background]="focusColor"></div>
      <div class="focus-info">
        <span class="focus-title">Focus Quality</span>
        <span class="focus-value" [style.color]="focusColor">
          {{ focusLabel }}
        </span>
      </div>
      <span class="focus-score" [style.color]="focusColor">
        {{ focusScore }}
      </span>
    </div>

    <div class="focus-checking" *ngIf="isFocusChecking">
      <div class="mini-spinner"></div>
      <span>Checking focus...</span>
    </div> -->

    <!-- Preview Top -->
    <div class="preview-top" *ngIf="!isProcessing">
      <!-- <span class="preview-label">Preview</span> -->
      <!-- <button class="preview-icon-btn" (click)="retake()">
        <ion-icon name="close"></ion-icon>
      </button> -->
    </div>

    <!-- Manual Rotate Controls -->
    <div class="rotate-bar" *ngIf="!isProcessing">
      <button class="rotate-btn" (click)="rotateImg(-90)">
        <ion-icon name="refresh-outline" class="flip-icon"></ion-icon>
      </button>
      <button class="rotate-btn" (click)="rotateImg(90)">
        <ion-icon name="refresh-outline"></ion-icon>
      </button>
    </div>

    <div class="processing-overlay" *ngIf="isProcessingPhoto">
      <div class="processing-content">
        <ion-spinner name="crescent" color="light"></ion-spinner>
        <p>{{'custom_camera.saving_photo' | translate}}</p>
      </div>
    </div>
    <!-- Preview Bottom -->
    <div class="preview-bottom" *ngIf="!isProcessing">
      <button class="action-btn retake-btn" (click)="retake()">
        {{'custom_camera.retake_btn' | translate}}
      </button>
      <button class="action-btn save-btn" (click)="usephoto()">
        {{'custom_camera.use_photo_btn' | translate}}
      </button>
    </div>

  </div>

  <!-- Your existing video element -->

  <canvas #canvasElement style="display:none;"></canvas>
</ion-content>

<div *ngIf="permissionDenied" class="permission-banner">

  <div class="pb-icon-wrap">
    <ion-icon name="camera-off-outline"></ion-icon>
  </div>

  <p class="pb-title">{{'custom_camera.camera_access_block' | translate}}</p>
  <p class="pb-subtitle">{{'custom_camera.allow_camera_access' | translate}}</p>

  <div class="pb-steps">
    <p class="pb-steps-label">{{'custom_camera.how_to_handle' | translate}}</p>

    <ol *ngIf="browser === 'chrome'">
      <li><span class="step-num">1</span><span
          [innerHTML]="'custom_camera.permission_text_chrome_step1' | translate"></span></li>
      <li><span class="step-num">2</span><span
          [innerHTML]="'custom_camera.permission_text_chrome_step2' | translate"></span></li>
      <li><span class="step-num">3</span><span
          [innerHTML]="'custom_camera.permission_text_chrome_step3' | translate"></span></li>
      <li><span class="step-num">4</span><span
          [innerHTML]="'custom_camera.permission_text_chrome_step4' | translate"></span></li>
      <li><span class="step-num">5</span><span
          [innerHTML]="'custom_camera.permission_text_chrome_step5' | translate"></span></li>
    </ol>

    <ol *ngIf="browser === 'safari'">
      <li><span class="step-num">1</span><span
          [innerHTML]="'custom_camera.permission_text_safari_step1' | translate"></span></li>
      <li><span class="step-num">2</span><span
          [innerHTML]="'custom_camera.permission_text_safari_step2' | translate"></span></li>
      <li><span class="step-num">3</span><span
          [innerHTML]="'custom_camera.permission_text_safari_step3' | translate"></span></li>
      <li><span class="step-num">4</span><span
          [innerHTML]="'custom_camera.permission_text_safari_step4' | translate"></span></li>
      <li><span class="step-num">5</span><span
          [innerHTML]="'custom_camera.permission_text_safari_step5' | translate"></span></li>
    </ol>

    <ol *ngIf="browser === 'firefox'">
      <li><span class="step-num">1</span><span
          [innerHTML]="'custom_camera.permission_text_firefox_step1' | translate"></span></li>
      <li><span class="step-num">2</span><span
          [innerHTML]="'custom_camera.permission_text_firefox_step2' | translate"></span></li>
      <li><span class="step-num">3</span><span
          [innerHTML]="'custom_camera.permission_text_firefox_step3' | translate"></span></li>
    </ol>

    <ol *ngIf="browser === 'edge'">
      <li><span class="step-num">1</span><span
          [innerHTML]="'custom_camera.permission_text_edge_step1' | translate"></span></li>
      <li><span class="step-num">2</span><span
          [innerHTML]="'custom_camera.permission_text_edge_step2' | translate"></span></li>
      <li><span class="step-num">3</span><span
          [innerHTML]="'custom_camera.permission_text_edge_step3' | translate"></span></li>
    </ol>

    <ol *ngIf="browser === 'other'">
      <li><span class="step-num">1</span><span
          [innerHTML]="'custom_camera.permission_text_other_step1' | translate"></span></li>
      <li><span class="step-num">2</span><span
          [innerHTML]="'custom_camera.permission_text_other_step2' | translate"></span></li>
      <li><span class="step-num">3</span><span
          [innerHTML]="'custom_camera.permission_text_other_step3' | translate"></span></li>
    </ol>
  </div>

  <button class="pb-retry-btn" (click)="startCamera(0)">{{'custom_camera.custom_camera_try_again_btn' |
    translate}}</button>

</div>